import { Magic } from "magic-sdk";
export default Magic;
